/**
 * Pure helpers for WhatsApp call-permission payloads (no I/O).
 */

/**
 * @param {{ appId?: string|null, platformRetailerId?: string|null }} [scope]
 * @returns {{ appId?: string, platformRetailerId?: string }}
 */
export function buildCallPermissionLineScope(scope = {}) {
  const appId = scope?.appId;
  if (appId == null || appId === '') return {};

  return {
    appId: String(appId),
    ...(scope.platformRetailerId
      ? { platformRetailerId: String(scope.platformRetailerId) }
      : {})
  };
}

export function getPermissionRequestErrorMessage(error) {
  if (!error) return null;
  if (typeof error === 'string') return error;

  return error.error
    || error.message
    || error.responseJSON?.error
    || error.responseJSON?.message
    || error.response?.data?.error
    || error.response?.data?.message
    || error.errors
    || null;
}

export function normalizeCallingPermission(input) {
  if (!input || typeof input !== 'object') return null;

  const permissionStatusRaw = input.permissionStatus ?? input.permission_status;
  const normalizedPermissionStatus = permissionStatusRaw === 'none'
    ? 'no_permission'
    : permissionStatusRaw;

  const canStartCall = input.canStartCall ?? input.can_start_call;
  const canRequestPermission = input.canRequestPermission ?? input.can_request_permission;

  return {
    canStartCall: canStartCall === true,
    canRequestPermission: canRequestPermission === true,
    permissionStatus: normalizedPermissionStatus,
    permissionExpiresAt: input.permissionExpiresAt ?? input.permission_expires_at
  };
}
